<template>
  <div id="main-wrapper">
    <div v-if="success">
      <div class="mfp-bg animated zoomIn mfp-ready"></div>
      <div class="mfp-wrap mfp-close-btn-in mfp-auto-cursor animated zoomIn mfp-ready" tabindex="-1" style="overflow: hidden auto;">
        <div class="mfp-container mfp-s-ready mfp-inline-holder">
          <div class="mfp-content">
            <div id="upload-confirm" class="white-popup-block popup-content popup-small">
              <div class="content t-white t-center">
                <p>{{$t('account.trading_account_label')}}</p>
              </div>
              <div class="btn-holder t-center">
                <a href="#" class="btn btn-lblue close-popup" @click.prevent="success = false">{{$t('account.ok')}} </a>
              </div>
              <button title="Close (Esc)" type="button" class="mfp-close" @click.prevent="success = false">×</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="content-container profile-page support-page add-label">
      <div class="page-wrap">
        <div class="page-content clearfix">
          <div class="main-content f-left">
            <div class="title-holder">
              <h4>{{$t('account.add_account_label')}}</h4>
            </div>
            <div class="content-holder">
              <div class="row-sec">
                <div class="form-holder wow fadeInLeft colu">
                  <Form @submit="submit">
                    <ul class="clearfix">
                      <li>
                        <label for="">{{$t('account.trading_account')}}</label>
                        <!-- <Field
                          class="form-control"
                          as="select"
                          name="account"
                          rules="required"
                          v-model="form.id"
                          @change="setLabel"
                        >
                          <option value="" disabled>
                            Select Trading Account
                          </option>
                          <option
                            v-for="account of store.tradingAccounts.records"
                            :value="account.id"
                            :key="account.account_id"
                          >
                            {{ account.account_id }} ({{
                              account.demo_live == "1" ? "Live" : "Demo"
                            }})
                          </option>
                        </Field>
                        <ErrorMessage name="id" /> -->
                        <select class="form-control" name="account" v-model="form.account_id"  @change="setLabel">
                            <option value="" label="Select Trading ID">{{$t('account.select_trading_id')}}</option>
                            <optgroup label="Demo MT4">
                              <option :value="list.account_id" v-for="list,index in MergeAcc('0','MT4')" :key ="index" >{{list.account_id}}</option>
                            </optgroup>
                            <optgroup label="Demo MT5">
                              <option :value="list.account_id" v-for="list,index in MergeAcc('0','MT5')" :key ="index" >{{list.account_id}}</option>
                            </optgroup>
                            <optgroup label="Live MT4">
                              <option :value="list.account_id" v-for="list,index in MergeAcc('1','MT4')" :key ="index" >{{list.account_id}}</option>
                            </optgroup>
                            <optgroup label="Live MT5">
                              <option :value="list.account_id" v-for="list,index in MergeAcc('1','MT5')" :key ="index" >{{list.account_id}}</option>
                            </optgroup>
                            <optgroup label="Live ZTP">
                              <option :value="list.account_id" v-for="list,index in MergeAcc('1','ZTP')" :key ="index" >{{list.account_id}}</option>
                            </optgroup>
                        </select>
                      </li>
                      <li>
                        <label for="">{{$t('account.label')}}</label>
                        <Field
                          name="label"
                          rules="required"
                          v-model="form.label"
                        />
                        <ErrorMessage name="label" />
                        <div class="note">
                          <p>{{$t('account.alpha_numeric_characters')}}</p>
                        </div>
                      </li>
                    </ul>
                    <div class="btn-holder t-center">
                      <button
                        type="submit"
                        class="btn btn-yellow btn-pop-up popup-link-holder"
                        name="button"
                      >
                      {{$t('account.apply')}}
                      </button>
                      <router-link to="/manage-account" class="btn btn-blue">
                        {{$t('account.cancel')}}
                      </router-link>
                    </div>
                  </Form>
                </div>
                <div class="img-holder t-center colu wow fadeInRight">
                  <img src="assets/images/label-img.png" alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useMainStore } from "@/store";
import { Form, Field, ErrorMessage } from "vee-validate";

export default {
  setup() {
    const store = useMainStore();
    return { store };
  },
  data() {
    return {
      form: {
        id: "",
        label: "",
        account_id: null,
      },
      success : false
    };
  },
  mounted() {
    this.form.account_id = this.store.lastSelectedAccount.account_id;
    this.form.id = this.store.lastSelectedAccount.id;
    this.form.label = this.store.lastSelectedAccount.label;
  },
  components: {
    Form,
    Field,
    ErrorMessage,
  },
  methods: {
    submit() {
      this.store.updateLabel(this.form, true,this);
    },
    MergeAcc(acc_type,platform){
        let demoMT4 = this.store.tradingAccounts.records.filter(i => i.demo_live == acc_type && i.platform == platform).map(val => val)
        return demoMT4 || []
    },
    setLabel(e) {
      const account = this.store.tradingAccounts.records.filter(
        (i) => i.account_id == e.target.value
      );
      this.form.label = account[0].label;
      this.form.account_id = account[0].account_id;
    },
  },
};
</script>
